import {Grid, useTheme} from "@mui/material";
import DealMenu from "../components/DealMenu";
import {Item} from "../../../domains/common/components/Item";
import RealtyFormContainer from "../components/Realty";
import {DealStatementTypes, RolesEnums} from "../../../enums";
import {FilesListContainer} from "../components/FilesContainer";
import {XmlList} from "../components/XmlList";
import React, {useState} from "react";
import {FormInput, FormInputDate} from "../../../domains/common/components/FormInput";
import {additionalStatementTypes} from "../../../dictionaries";
import FormSelect from "../../../domains/common/components/FormSelect";
import {Responsible} from "../components/Responsible";
import DealCommentContainer from "../components/Comment";
import {dealData} from "../deal";
import {waitInputComplete} from "../../../fn";
import {ParticipantsComponent} from "../components/Participants";

/**
 * Тип сделки - Регистрация дополнительных заявлений
 * @param dealData
 * @param id
 * @returns {Element}
 * @constructor
 */
export function DealAddStatementContainer() {
  const theme = useTheme();

  return (
    <Grid container spacing={1} sx={{mt: 0.2}}>
      <Grid item xs={12}>
        <DealMenu dealId={dealData.dealId}></DealMenu>
      </Grid>
      <Grid item xs={12}>
        <Item sx={{backgroundColor: theme.palette.background.default}}>
          <RealtyFormContainer values={dealData.realty}/>
        </Item>
      </Grid>

      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <ParticipantsComponent role={RolesEnums.DECLARANT}/>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <FilesListContainer/>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <XmlList value={dealData?.dealXmlStatementsList}/>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <Responsible value={dealData.user}/>
            </Item>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <ParticipantsComponent role={RolesEnums.REPRESENTATIVE} />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{ backgroundColor: theme.palette.background.default }}>
              <ParticipantsComponent role={RolesEnums.EXT_SIGNER} />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <DealCommentContainer />
            </Item>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export function DKPAddStatementParamsContainer({onChange}) {
  const [statementType, setStatementType] = useState(dealData.deal.statementType)

  const handleStatmentTypeChange = (e) => {
    onChange ? onChange({statementType: e.target.value}) : void 0
    setStatementType(e.target.value)
  }

  const handleKuvdChange = waitInputComplete((e) => onChange({kuvdNumber: e.target.value}), 1500)

  const handleRegDate = (value) => {
    onChange({kuvdDate: value})
  }

  const handlePeriodOfSuspension = (value) => {
    onChange({periodOfSuspension: value})
  }

  return (
    <Grid container>
      <Grid item sx={{width: 250, pt: '7px'}}>
        <Grid container>
          <Grid item xs={12}>
            <FormInput label="Номер КУВД"
              name="kuvdNumber"
              onChange={handleKuvdChange}
              value={dealData?.deal?.kuvdNumber}
                       disabled={!!dealData?.deal?.kuvdNumber}/>
          </Grid>
          <Grid item xs={12} sx={{height: 12}}></Grid>
          <Grid item xs={12}>
            <FormInputDate label="Дата регистрации"
              name="kuvdDate"
              onChange={handleRegDate}
              value={dealData?.deal?.kuvdDate}
                           disabled={!!dealData?.deal?.kuvdDate}/>
          </Grid>
        </Grid>
      </Grid>
      <Grid item sx={{width: 250, pt: '7px'}}>
        <Grid container>
          <Grid item xs={12}>
            <FormSelect elemId="registrationTypeSelect" name="statementType"
                        data={additionalStatementTypes} label="Тип заявления" minWidth={250}
                        maxWidth={450} value={dealData?.deal?.statementType}
                        onChange={handleStatmentTypeChange}/>
          </Grid>
          <Grid item xs={12} sx={{height: 12}}></Grid>
          {statementType === DealStatementTypes.SUSPEND_REG && (
            <Grid item xs={12}>
              <FormInputDate
                label="Дата приостановки"
                name="kuvdDate"
                onChange={handlePeriodOfSuspension}
                value={dealData?.deal?.periodOfSuspension}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}